import { AsyncPipe, DecimalPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable, combineLatest, map } from 'rxjs';

import { ProductContextFacade } from 'ish-core/facades/product-context.facade';
import { PriceHelper } from 'ish-core/models/price/price.helper';
import { Price, Pricing } from 'ish-core/models/price/price.model';
import { PricePipe } from 'ish-core/models/price/price.pipe';
import { ProductHelper } from 'ish-core/models/product/product.model';

@Component({
  selector: 'custom-product-price-total',
  templateUrl: './custom-product-price-total.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, AsyncPipe, DecimalPipe, PricePipe, TranslateModule],
})
export class CustomProductPriceTotalComponent implements OnInit {
  private context = inject(ProductContextFacade);

  readonly showInformationalPrice = input<boolean>(undefined);
  readonly showPriceSavings = input<boolean>(undefined);
  readonly showScaledPrices = input(true);
  readonly range = input<number>(undefined);
  visible$: Observable<boolean>;
  isPriceRange$: Observable<boolean>;
  quantity$: Observable<number>;
  data$: Observable<
    {
      isListPriceGreaterThanSalePrice: boolean;
      isListPriceLessThanSalePrice: boolean;
      priceSavings: Price;
      lowerPrice: Price;
      upperPrice: Price;
    } & Pricing
  >;

  ngOnInit() {
    this.visible$ = this.context.select('displayProperties', 'price');
    this.isPriceRange$ = this.context
      .select('product')
      .pipe(map(product => ProductHelper.isMasterProduct(product) || ProductHelper.isRetailSet(product)));

    this.data$ = combineLatest([this.context.select('product'), this.context.select('prices')]).pipe(
      map(([product, prices]) => ({
        ...prices,
        isListPriceGreaterThanSalePrice: prices.listPrice?.value > prices.salePrice?.value,
        isListPriceLessThanSalePrice: prices.listPrice?.value < prices.salePrice?.value,
        priceSavings: prices.listPrice && prices.salePrice && PriceHelper.diff(prices.listPrice, prices.salePrice),
        lowerPrice:
          (ProductHelper.isMasterProduct(product) || ProductHelper.isRetailSet(product)) && prices.minSalePrice,
        upperPrice: ProductHelper.isMasterProduct(product)
          ? prices.maxSalePrice
          : ProductHelper.isRetailSet(product)
          ? prices.summedUpSalePrice
          : undefined,
      }))
    );

    this.quantity$ = this.context.select('quantity');
  }

  getTotalPrice(price: Price, quantity: number): Price {
    return {
      ...price,
      value: price.value * quantity,
    };
  }
}
